var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.room)?_c('h5',{staticClass:"font-weight-regular",style:(`color: white`)},[_vm._v(" "+_vm._s(_vm.room.title)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }